import styled, { css } from 'styled-components'
import {
  GRAY2,
  PRIMARY_TEXT,
  GRAY4,
  DB_AZURE,
  SUMMER_SKY_RGB,
  SLA_GRAY,
} from 'constants/colors'
import { Flex } from '../styles'

export const ModalHeader = styled(Flex)`
  padding: 15px 16px;
  border-bottom: 1px solid ${GRAY2};
  background: ${GRAY4};

  > button {
    padding: 0;
    margin-left: auto;
  }
`

export const ModalTitle = styled.div`
  color: ${PRIMARY_TEXT};
  font-size: 16px;
  font-weight: 500;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`

export const ModalFooter = styled(Flex)`
  padding: 8px 16px;
  border-top: 1px solid ${GRAY2};
  background: ${GRAY4};
`

export const ModalContent = styled.div`
  padding: 16px;
`

export const TextFieldContainer = styled.div`
  margin-top: 10px;

  input {
    border: 1px solid ${GRAY2};
    border-radius: 8px;
    padding: 12px 16px;
    height: 22px;

    &:focus {
      border-color: ${DB_AZURE};
      box-shadow: 0 0 2px 4px rgba(${SUMMER_SKY_RGB}, 0.3);
      background: transparent;
    }
  }
`

export const SignatureContainer = styled.div<{ isMobileView: boolean }>`
  height: 400px;

  > canvas {
    width: 400px;
    height: 400px;
    border-radius: 8px;
    border: 1px dashed ${SLA_GRAY};
    border-radius: 8px;
    background: ${GRAY4};
  }

  ${({ isMobileView }) =>
    isMobileView &&
    css`
      > canvas {
        width: 100%;
      }
    `}
`

export const SavedSignatureContainer = styled(Flex)<{ isMobileView: boolean }>`
  width: 400px;
  height: 400px;
  border-radius: 8px;
  border: 1px dashed ${SLA_GRAY};
  border-radius: 8px;
  background: ${GRAY4};

  > img {
    max-width: 400px;
    max-height: 400px;
  }

  ${({ isMobileView }) =>
    isMobileView &&
    css`
      width: 100%;

      > img {
        max-width: 100%;
      }
    `}
`
